import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import { router } from "@/router";
import ThemeProvider from "@/providers/ThemeProvider";
import { QueryProvider } from "./providers/QueryProvider";

import "./font.css";
import "./i18n";

console.log(
  "%cs%ce%c%cf%cano",
  "color:#4C9A93; font-size:64px; font-weight:800; font-family:sans-serif;",
  "color:#4C9A93; font-size:64px; font-weight:800; font-family:sans-serif;",
  "color:#4C9A93; font-size:64px; font-weight:800; font-family:sans-serif;",
  "color:#116B64; font-size:64px; font-weight:900; font-family:sans-serif;",
  "color:#4C9A93; font-size:64px; font-weight:800; font-family:sans-serif;",
);

console.log(
  "%cpowerd by %cSEFANO %cteam",
  "color:#4C9A93; font-family:sans-serif;",
  "color:#116B64; font-size:20px; font-weight:900; font-family:sans-serif;",
  "color:#4C9A93; font-family:sans-serif;",
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryProvider>
  </React.StrictMode>,
);
